import React, {Component, Fragment} from 'react';

import { AiOutlineFileImage, AiOutlineVideoCameraAdd, AiOutlineAppstoreAdd, AiFillDelete } from "react-icons/ai";
import { FaSpinner } from "react-icons/fa";



import * as Constant from '@app/Constant.js';

import axios from '@app/lib/axios';


import { AgGridReact } from 'ag-grid-react';

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';



class Devices extends Component {

	constructor(props) {
		super(props);

		window.disconnectDevice = this.disconnectDevice;
		this.state= {
			isLoaded : true,
			msg : "",
			id : this.props.id || 0,
			devices : this.props.devices || []
		};
	}

    getDevices = () => {
		this.setState(
			{isLoaded : false, msg : "데이터 로딩 중입니다."}, 
			() => {
				axios({
			          method: "get",
			          url: Constant.API_DOMAIN+`/api/flyeng/parent/devices/${this.state.id}`
			        })
				    .then(result => {
				        if(result.data.code === 200) {  
			        		this.setState({
			        			isLoaded : true,
								devices : result.data.devices || []
							});
				        } else {
							alert(result.data.msg);
				        }
				        
				      })
				      .catch(error => {
				        console.log(error);
				        console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
				    });
				    
			}

		);
    }

    disconnectDevice = (id) => {
		if(window.confirm("선택하신 기기의 연결을 해제하시겠습니까?\n연결 해제 된 기기에서는 재로그인이 필요합니다.")) {
    		axios({
	          method: "delete",
	          url: Constant.API_DOMAIN+`/api/flyeng/parent/device/${id}`
	        })
		    .then(result => {
		        if(result.data.code === 200) {  
	        		alert(result.data.msg);
		        } else {
					alert(result.data.msg);
		        }
		        this.getDevices();
		      })
		      .catch(error => {
		        console.log(error);
		        console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
		    });
    	}
	}

	defaultColDef = {
		headerClass:'bg-dark text-light',
	};
    listColumn = [
    	{
		    headerName: "기기",
		    field: "device_model",
		    sortable: false,
		    minWidth : 180,
		    resizable : true,
		    cellClass: "text-center",
		    filter: false
		},
		{
		    headerName: "생성 시각",
		    field: "create_date",
		    sortable: false,
		    minWidth : 180,
		    resizable : true,
		    cellClass: "text-center",
		    filter: false
		},
		{
		    headerName: "마지막 접속",
		    field: "update_date",
		    sortable: false,
		    minWidth : 180,
		    resizable : true,
		    cellClass: "text-center",
		    filter: false
		},
		{
		    headerName: "연결",
		    field: "id",
		    sortable: false,
		    width : 80,
		    resizable : true,
		    cellClass: "text-center",
		    filter: false,
		    cellRenderer : (params) => {
		    	return "<button class='btn btn-danger btn-sm' onclick='disconnectDevice("+params.value+")'>연결해제</button>";
		    }
		}
	];


	onGridReady = params => {
		this.gridApi = params.api;
        params.api.sizeColumnsToFit();
    }

	render() {
		if(this.state.isLoaded) {
			return (
					<Fragment>
						<h5>접속 기기 관리</h5>
						<div className="card border-top ag-theme-balham">
		                    <div className="card-body" style={{height : "185px", padding :"0px"}}>
		                        <AgGridReact
								  onGridReady={this.onGridReady}
								  defaultColDef={this.defaultColDef}
						          columnDefs={this.listColumn}
						          rowData={this.state.devices}	
						          rowHeight={40}
						        />
		                    </div>
						</div>
					</Fragment>
			
			)
		} else {
			return (
				<Fragment>
					<h5>접속 기기 관리</h5>
	                <div className="card border-top">
	                    <div className="card-body" style={{height:this.props.height + "px", textAlign:"center", padding:"50px"}}>
	                        <span className="dashboard-spinner spinner-xxl"></span>
	                        <div style={{marginTop : "15px"}}>
	                        	<p>{this.state.msg}</p>
	                        	<p>{this.state.uploading}</p>
	                        </div>
	                    </div>
	                </div>
	            </Fragment>
            )
		}
		
	}
};

export default Devices ;